import React from 'react';
import calendarSVG from './calendar.svg'
import LinkCell3 from "../LinkCell3/LinkCell3";
import {useParams} from "react-router-dom";

function ToCalendar(props) {
    const {orgName} = useParams()
    return (
        <div className={'row__cell'}>
            <LinkCell3
                linkRoute={process.env.REACT_APP_URL_PREFIX + `/calendar/${props.cellContent}/${props.idArr[0]}/${orgName ? orgName : ''}`}
                linkTitle={
                    <img src={calendarSVG} alt="toCalendar"/>
                } editClick={false}/>
        </div>
    );
}

export default ToCalendar;
